import type { ChartComponent } from './chart.component';

export class ChartEvent {
  originalEvent: Event;
  context: ChartComponent;

  constructor(event: Event, context: ChartComponent) {
    this.originalEvent = event;
    this.context = context;
  }
}
